import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown, DropdownOptionProps } from '@wix/wix-ui-tpa';
import { getCurrentTimeSlotId, refreshTimeSlotsAtNextBoundary, getAvailableTimeSlots } from './TimeSlotsDropdown.utils';
import { classes } from './TimeSlotsDropdown.st.css';
import s from './TimeSlotsDropdown.scss';
import cx from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';

export type TimeSlotsDropdownProps = {
  selectedId: string | undefined;
  disabled: boolean;
  isToday: boolean;
  onChange: (option: DropdownOptionProps) => void;
};

export enum TimeSlotsDropdownDataHooks {
  dropdown = 'rise-gift-card-time-picker',
}

export const TimeSlotsDropdown: React.FC<TimeSlotsDropdownProps> = ({
  selectedId,
  disabled,
  isToday,
  onChange,
}) => {
  const { t } = useTranslation();
  const [currentTimeSlotId, setCurrentTimeSlotId] = useState(() => getCurrentTimeSlotId());

  useEffect(() => {
    if (!isToday) {
      return;
    }
    return refreshTimeSlotsAtNextBoundary(setCurrentTimeSlotId);
  }, [isToday]);

  const options = useMemo(() => getAvailableTimeSlots(isToday), [isToday, currentTimeSlotId]);

  return (
    <Dropdown
      className={cx(classes.timeSlotsDropdown, s.timeSlotsDropdown)}
      data-hook={TimeSlotsDropdownDataHooks.dropdown}
      placeholder={t('giftCardPage.deliveryTime.expiration.now')}
      options={options}
      selectedId={selectedId}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
